import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './LoadError.sass'
import { extractMessageFromError } from 'utils/error-util'
import Button from 'components/Button'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  error: unknown
  onRetryClick?: () => unknown
}

export default observer(function LoadError({ error, onRetryClick }: Props) {
  return (
    <div className={cx(styles.root)}>
      <div className={styles.message}>{extractMessageFromError(error)}</div>
      <div className={styles.actions}>
        <Button flat type="danger" onClick={onRetryClick}>
          Try again
        </Button>
      </div>
    </div>
  )
})
